/* istanbul ignore file */

import { Carriers } from '../constants/carriers';
import ameritasUri from './assets/ameritas.jpg';
import { CarrierConfig } from './carrierConfig';

export class CarrierAmeritas extends CarrierConfig {
  getCarrier(): Carriers {
    return Carriers.AMERITAS;
  }
  getCarrierDisplayName(): string {
    return 'Ameritas Life Insurance Corp';
  }
  getLabel(): string {
    return 'Ameritas';
  }
  supportLetterGeneration(): boolean {
    return true;
  }
  getCarrierLogo(): string {
    return ameritasUri;
  }
}
